import React, { PureComponent, Fragment } from "react";

import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

import {
  StandardTooltip,
  PIE_COLORS,
  Error,
  selectFormat,
} from "components/Utils/Utils.js";

class HearstDeviceName extends PureComponent {
  constructor(props) {
    super(props);
    const deviceName = props.data.data.map((d) => {
      return {
        name: d.name,
        value: d.value.value,
        deviceName: d.deviceName.map((dn) => ({
          name: dn.name,
          value: dn.value,
          change: dn.change,
        })),
        change: d.value.change,
      };
    });
    this.state = {
      deviceName,
      activeData: deviceName,
    };
  }

  componentDidMount() {
    this.props.childRef(this);
  }

  generateDataForExport = () => {
    const data = this.state.activeData;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Network: data[i].name,
        Value: selectFormat("number", data[i].value, "0,000"),
        Percentage: selectFormat("percentage", data[i].change),
        // numeral(data.click_rate_30).divide(100).format('%')
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  handleClick = (entry, index) => {
    const deviceName = this.state.deviceName.find((d) => d.name === entry.name);
    if (!deviceName) {
      this.setState({
        activeData: this.state.deviceName,
      });
    } else {
      this.setState({
        activeData: deviceName.deviceName.slice(0, 6),
      });
    }
  };

  renderCell = (entry, index) => {
    return (
      <Cell
        key={index}
        onClick={() => this.handleClick(entry, index)}
        fill={PIE_COLORS[index % PIE_COLORS.length]}
      />
    );
  };

  render() {
    const { data } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="col-12">
        <div className="row">
          <div className="col-12 pt-3">
            <ResponsiveContainer height={400}>
              <PieChart>
                <Pie
                  data={this.state.activeData}
                  dataKey="value"
                  innerRadius={95}
                  outerRadius={150}
                  isAnimationActive={false}
                  label={({
                    cx,
                    cy,
                    midAngle,
                    innerRadius,
                    outerRadius,
                    value,
                    index,
                  }) => {
                    const RADIAN = Math.PI / 180;
                    const radius =
                      25 + innerRadius + (outerRadius - innerRadius);
                    const x = cx + radius * Math.cos(-midAngle * RADIAN);
                    const y = cy + radius * Math.sin(-midAngle * RADIAN);

                    return (
                      <text
                        x={x}
                        y={y}
                        fill={PIE_COLORS[index % PIE_COLORS.length]}
                        textAnchor={x > cx ? "start" : "end"}
                        dominantBaseline="central"
                      >
                        {/* {data.data[index].name} ({value.toFixed(0)}%) */}
                        {this.state.activeData[index].name} (
                        {selectFormat("number", value)})
                      </text>
                    );
                  }}
                >
                  {this.state.activeData.map(this.renderCell)}
                </Pie>

                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.state.activeData);

                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__key-header">
                                  Device Name
                                </span>
                              </header>

                              <main className="standard-tooltip__main">
                                {Object.keys(payload)
                                  .sort(
                                    (a, b) =>
                                      payload[b].value - payload[a].value
                                  )
                                  .filter((key) => payload[key].value > 0)
                                  .map((key) => (
                                    <Fragment key={key}>
                                      <div className="standard-tooltip__item">
                                        <span
                                          className="standard-tooltip__key"
                                          style={{
                                            color: payload[key].payload.fill,
                                          }}
                                        >
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{
                                              background:
                                                payload[key].payload.fill,
                                            }}
                                          />
                                          {payload[key].payload.name}
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat(
                                            "number",
                                            payload[key].payload.value
                                          )}
                                        </span>
                                      </div>
                                    </Fragment>
                                  ))}
                              </main>
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default HearstDeviceName;
